import React from 'react';
import { Copy, Filter } from 'lucide-react';

interface DuplicateToggleProps {
  hideDuplicates: boolean;
  onToggle: (hideDuplicates: boolean) => void;
  duplicateCount?: number;
  totalCount?: number;
  className?: string;
}

export const DuplicateToggle: React.FC<DuplicateToggleProps> = ({
  hideDuplicates,
  onToggle,
  duplicateCount = 0,
  totalCount = 0,
  className = ''
}) => {
  const uniqueCount = totalCount - duplicateCount;
  
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onToggle(!hideDuplicates)}
          className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
            hideDuplicates
              ? 'bg-blue-600 text-white hover:bg-blue-700'
              : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
          }`}
          title={hideDuplicates ? 'Show all occurrences' : 'Hide duplicate findings'}
        >
          <Filter className="w-4 h-4" />
          {hideDuplicates ? 'Hide duplicates' : 'Show all'}
        </button>
        
        {duplicateCount > 0 && (
          <div className="flex items-center gap-1 text-xs text-gray-400">
            <Copy className="w-3 h-3" />
            <span>
              {hideDuplicates 
                ? `${duplicateCount} duplicates hidden`
                : `${uniqueCount} unique, ${duplicateCount} duplicates`
              }
            </span>
          </div>
        )}
      </div>
    </div>
  );
}; 